let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fAgCm")).then(() => parcelRequire('6h9YI'));